@if (powerSource == PowerSource.AC_POWER) {
  <app-icon [size]="size" name="ic_ac_power" />
} @else if (powerSource == PowerSource.BATTERY) {
  @if (batteryLevel) {
    <app-text-with-icon
      [size]="size"
      [name]="batteryLevel < 0.5 ? 'ic_battery_low' : 'ic_battery'"
    >
      {{ batteryLevel | localizedPercent }}
    </app-text-with-icon>
  } @else {
    <app-icon [size]="size" name="ic_battery" />
  }
}
